var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWireHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mit_bl._Kreislinie",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#009fe3;}.cls-3{stroke:#fff;stroke-width:.76px;}.cls-3,.cls-4,.cls-5,.cls-6{fill:none;}.cls-5{clip-path:url(#clippath);}.cls-6{stroke:#009fe3;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multisystem_Auswahltool"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.8,57.56l-.39.15c-1.25-2.69-5.89-2.75-7.56-2.67-1.46-2.61-5.67-2.56-6.94-2.48v-8.87c0-5.38-7.45-5.38-7.45,0v24.55c0-2.32-1.33-3.29-3.23-4.97-4.64-4.09-9.07,1.23-5.34,4.97,8.33,8.33,11.05,15.73,11.05,23.6h22.35s.32-4.47,1.99-8.63c1.76-4.39,2.98-10.74,2.98-15.63v-5.47c0-5.47-7.45-4.55-7.45-4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m75.36,94.21c15.34,0,27.77-12.74,27.77-28.46s-12.43-28.46-27.77-28.46-27.77,12.74-27.77,28.46,12.43,28.46,27.77,28.46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 75.36,
    cy: 65.75,
    rx: 24.86,
    ry: 25.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.36,79.11c7.2,0,13.04-5.98,13.04-13.36s-5.84-13.36-13.04-13.36-13.04,5.98-13.04,13.36,5.84,13.36,13.04,13.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.36,46.49c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.08,46.49c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.36,50.13c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.08,50.13c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.83,83.41c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.55,83.41c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.83,87.06c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.55,87.06c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.51,54.97c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.23,54.97c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m89.51,58.62c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.23,58.62c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.09,71.97c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.81,71.97c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.09,75.62c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.81,75.62c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.45,81.49c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.17,81.49c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m63.45,85.13c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m67.17,85.13c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.38,66.81c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.1,66.81c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.38,70.46c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.1,70.46c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.07,52.66c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.8,52.66c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.07,56.31c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.8,56.31c.82,0,1.49-.67,1.49-1.49s-.67-1.49-1.49-1.49-1.49.67-1.49,1.49.67,1.49,1.49,1.49"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 75.14,
    cy: 75,
    r: 68.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.81,94.37c-1.73-1.53-4.55-1.46-5.44-1.4-.16-.22-.34-.42-.55-.6-1.73-1.53-4.55-1.46-5.44-1.4-.16-.22-.34-.42-.55-.6-1.35-1.19-3.36-1.41-4.6-1.42v-6.12c0-2.79-2.01-4.25-4-4.25s-4,1.46-4,4.25v16.03c-.29-.38-.6-.73-.94-1.03-2.38-2.1-4.82-1.62-6.07-.28-1.28,1.36-1.55,3.77.41,5.74,5.95,5.95,8.6,11.59,8.6,18.28v1h19.91l.07-.93s.26-3.48,1.53-6.64c1.48-3.68,2.47-8.88,2.47-12.96v-4.39c0-1.34-.48-2.48-1.39-3.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.2,102.05c0,3.77-.96,8.79-2.33,12.2-.98,2.45-1.4,4.99-1.57,6.32h-16.1c-.25-6.83-3.11-12.63-9.16-18.69-1.11-1.11-.97-2.31-.37-2.96.59-.63,1.81-.9,3.29.41,1.33,1.17,2.26,3.31,2.26,4.85h2v-21.35c0-1.55,1-2.25,2-2.25s2,.7,2,2.25v15.76h2v-7.64c1.01,0,2.46.19,3.28.93.48.43.71,1.01.71,1.78v4.9h2v-4.9c0-.25-.02-.48-.05-.71,1.02,0,2.49.18,3.33.93.48.43.71,1.01.71,1.78v4.9h2v-4.9c0-.25-.02-.48-.05-.72,1.01,0,2.48.18,3.33.93.48.43.72,1.01.72,1.79v4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m91.2,102.05c0,3.77-.96,8.79-2.33,12.2-.98,2.45-1.41,4.99-1.57,6.32h-16.1c-.25-6.83-3.11-12.63-9.16-18.69-1.11-1.11-.97-2.31-.37-2.96.59-.63,1.81-.9,3.29.42,1.33,1.17,2.26,3.31,2.26,4.85h2v-21.35c0-1.55,1-2.25,2-2.25s2,.7,2,2.25v15.76h2v-7.64c1.01,0,2.45.19,3.28.93.48.43.71,1.01.71,1.78v4.9h2v-4.9c0-.25-.02-.48-.05-.71,1.02,0,2.49.18,3.34.93.48.43.71,1.01.71,1.79v4.9h2v-4.9c0-.25-.02-.48-.05-.72,1.01,0,2.48.18,3.33.93.48.43.72,1.01.72,1.79v4.4Zm.61-7.68c-1.73-1.53-4.55-1.46-5.44-1.4-.16-.22-.34-.42-.55-.6-1.73-1.53-4.55-1.46-5.44-1.4-.16-.22-.34-.42-.55-.6-1.35-1.19-3.36-1.41-4.6-1.42v-6.12c0-2.79-2.01-4.25-4-4.25s-4,1.46-4,4.25v16.03c-.29-.38-.6-.73-.94-1.03-2.38-2.1-4.82-1.62-6.07-.28-1.28,1.36-1.55,3.77.41,5.74,5.95,5.95,8.6,11.59,8.6,18.28v1h19.91l.07-.93s.26-3.48,1.53-6.64c1.48-3.68,2.47-8.88,2.47-12.96v-4.39c0-1.34-.48-2.48-1.39-3.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m70.1,65.12c2.56,0,4.64-2.13,4.64-4.76s-2.08-4.76-4.64-4.76-4.64,2.13-4.64,4.76,2.08,4.76,4.64,4.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.63,65.12c2.56,0,4.64-2.13,4.64-4.76s-2.08-4.76-4.64-4.76-4.64,2.13-4.64,4.76,2.08,4.76,4.64,4.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m70.1,75.88c2.56,0,4.64-2.13,4.64-4.76s-2.08-4.76-4.64-4.76-4.64,2.13-4.64,4.76,2.08,4.76,4.64,4.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m80.63,75.88c2.56,0,4.64-2.13,4.64-4.76s-2.08-4.76-4.64-4.76-4.64,2.13-4.64,4.76,2.08,4.76,4.64,4.76"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireHand);
export default __webpack_public_path__ + "static/media/wire-hand.8b6aec1e2c0bc78ad4ab89fb8c5cd899.svg";
export { ForwardRef as ReactComponent };